// Mock API service for PropertyDocuments testing
const mockApi = {
  // Mock property data
  getProperty: (id) => {
    return {
      success: true,
      data: {
        id: parseInt(id),
        name: `Property ${id}`,
        address: `123 Main Street, City ${id}`,
        status: "active",
      },
    };
  },

  // Mock documents data
  getPropertyDocuments: (propertyId, page = 1) => {
    const allDocuments = [
      {
        id: 1,
        name: "Monthly Report - January 2024",
        created_at: "2024-01-15",
        reminder_sent: 0,
        type: "Monthly Report",
        file_size: "2.5 MB",
        file_type: "pdf",
      },
      {
        id: 2,
        name: "Electricity Bill - Q1 2024",
        created_at: "2024-01-10",
        reminder_sent: 0,
        type: "Electricity Bill",
        file_size: "1.2 MB",
        file_type: "pdf",
      },
      {
        id: 3,
        name: "Gas Bill - December 2023",
        created_at: "2023-12-28",
        reminder_sent: 1,
        type: "Gas Bill",
        file_size: "890 KB",
        file_type: "pdf",
      },
      {
        id: 4,
        name: "Floor Plans - Ground Floor",
        created_at: "2023-11-15",
        reminder_sent: 0,
        type: "Floor Plans",
        file_size: "3.1 MB",
        file_type: "pdf",
      },
      {
        id: 5,
        name: "Service Report - HVAC",
        created_at: "2023-10-20",
        reminder_sent: 0,
        type: "Service Report",
        file_size: "1.8 MB",
        file_type: "pdf",
      },
      {
        id: 6,
        name: "Water Bill - Q4 2023",
        created_at: "2023-10-15",
        reminder_sent: 0,
        type: "Water Bill",
        file_size: "950 KB",
        file_type: "pdf",
      },
      {
        id: 7,
        name: "Council Tax Bill - 2023/24",
        created_at: "2023-09-20",
        reminder_sent: 0,
        type: "Council Tax Bill",
        file_size: "1.1 MB",
        file_type: "pdf",
      },
      {
        id: 8,
        name: "Insurance Certificate - 2024",
        created_at: "2023-09-10",
        reminder_sent: 0,
        type: "Insurance Certificate",
        file_size: "2.3 MB",
        file_type: "pdf",
      },
      {
        id: 9,
        name: "Maintenance Schedule - 2024",
        created_at: "2023-08-25",
        reminder_sent: 0,
        type: "Maintenance Schedule",
        file_size: "1.7 MB",
        file_type: "pdf",
      },
      {
        id: 10,
        name: "Fire Safety Assessment - 2023",
        created_at: "2023-08-15",
        reminder_sent: 0,
        type: "Fire Safety Assessment",
        file_size: "3.5 MB",
        file_type: "pdf",
      },
      {
        id: 11,
        name: "Asbestos Survey Report",
        created_at: "2023-07-30",
        reminder_sent: 0,
        type: "Asbestos Survey",
        file_size: "4.2 MB",
        file_type: "pdf",
      },
      {
        id: 12,
        name: "Legionella Risk Assessment",
        created_at: "2023-07-20",
        reminder_sent: 0,
        type: "Legionella Assessment",
        file_size: "2.8 MB",
        file_type: "pdf",
      },
    ];

    const perPage = 5;
    const startIndex = (page - 1) * perPage;
    const endIndex = startIndex + perPage;
    const documents = allDocuments.slice(startIndex, endIndex);

    return {
      success: true,
      data: documents,
      pagination: {
        current_page: page,
        last_page: Math.ceil(allDocuments.length / perPage),
        per_page: perPage,
        total: allDocuments.length,
      },
    };
  },

  // Mock certificates data
  getPropertyCertificates: (propertyId) => {
    const certificates = [
      {
        id: 1,
        name: "Gas Safety Certificate",
        date_uploaded: "2024-01-15",
        reminder_sent: 0,
        type: "Gas Safety Certificate",
        file_size: "1.5 MB",
        file_type: "pdf",
      },
      {
        id: 2,
        name: "Electrical Safety Certificate",
        date_uploaded: "2024-01-10",
        reminder_sent: 1,
        type: "Electrical Safety Certificate",
        file_size: "2.1 MB",
        file_type: "pdf",
      },
      {
        id: 3,
        name: "Fire Safety Certificate",
        date_uploaded: "2023-12-20",
        reminder_sent: 0,
        type: "Fire Safety Certificate",
        file_size: "1.8 MB",
        file_type: "pdf",
      },
    ];

    return {
      success: true,
      data: certificates,
    };
  },

  // Mock process documents data
  getProcessDocuments: () => {
    const processDocuments = [
      {
        name: "On boarding process",
        value: "on_boarding_process",
        file_size: "2.3 MB",
        file_type: "pdf",
      },
      {
        name: "Hand back process",
        value: "hand_back_process",
        file_size: "1.9 MB",
        file_type: "pdf",
      },
    ];

    return {
      success: true,
      data: processDocuments,
    };
  },

  // Mock download functionality
  downloadPropertyDocument: (propertyId, documentId) => {
    return {
      success: true,
      message: `Document ${documentId} downloaded successfully`,
    };
  },

  // Mock delete functionality
  deletePropertyDocument: (propertyId, documentId) => {
    return {
      success: true,
      message: `Document ${documentId} deleted successfully`,
    };
  },

  // Mock get single document functionality
  getPropertyDocument: (documentId) => {
    const document = {
      id: parseInt(documentId),
      name: "Monthly Report - January 2024",
      type: "Monthly Report",
      visible_to_client: false,
      created_at: "2024-01-15",
      file_size: "2.5 MB",
      file_type: "pdf",
      property: {
        id: 1,
        name: "Property 1",
        address: "123 Main Street, City 1",
        status: "active",
      },
    };

    return {
      success: true,
      data: document,
    };
  },

  // Mock update document functionality
  updatePropertyDocument: (documentId, formData) => {
    // Simulate API validation
    if (!formData.name || formData.name.trim() === "") {
      return {
        success: false,
        message: "Name is required",
      };
    }

    if (formData.name.length > 100) {
      return {
        success: false,
        message: "Name must be less than 100 characters",
      };
    }

    return {
      success: true,
      message: `Document ${documentId} updated successfully`,
      data: {
        id: parseInt(documentId),
        ...formData,
      },
    };
  },
};

export default mockApi;
